import { useEffect, useState } from "react"
import { getUrlSearchParams } from "../../../urlParams"
import EmpresasSelecaoPage from "./EmpresasSelecaoPage"
import NotasSelecaoPage from "./NotasSelecaoPage"
import ViewNotaPage from "./ViewNotaPage"
import { ApiEndpoints, LinkEndpoint, reqGetNew } from "../../../../config/apiClient"
import { useDispatch } from "react-redux"
import { alterarStatusAtualizar, alterarStatusPrimeiroLoading, atualizar } from "./notasServicoSlice"

export default function EmissaoPage() {
    const [pagina, setPagina] = useState<"empresas" | "notas" | "view">('empresas')
    const [empresa, setEmpresa] = useState<any>({})
    const [nota, setNota] = useState<any>({})
    const [modeloNota, setModeloNota] = useState<any>({})
    const dispatch = useDispatch()
    const [filtros, setFiltros] = useState<iFiltrosDto>({ clientes: [], clientes_tipos: [], servicos: [], servicos_mun: [], servicos_antigos: [], servicos_empresas: [], cidades: [], empresas: [], modelos: [] })
    useEffect(() => {
        document.title = 'NFSe NOTAS | OB PORTUS'
        loadPagina()
        // eslint-disable-next-line
    }, [])

    function handleResetStatus() {
        dispatch(atualizar({notas: [], competencias: []}))
        dispatch(alterarStatusAtualizar({atualizar: true}))
        dispatch(alterarStatusPrimeiroLoading({primeiro_loading: true}))
    }
    async function loadPagina() {
        const filtrosAux = await getFiltros()
        const paginaDados = definirPagina(false)
        let empresaAux:any = {}
        let notaAux = {}
        if (paginaDados.urlDados.id_empresa > 0) {
            const id_empresa = paginaDados.urlDados.id_empresa
            const empresa = filtrosAux.empresas.filter((reg) => reg.id_empresa === id_empresa)[0]
            empresaAux = empresa
        }
        if (paginaDados.urlDados.id_nota > 0) {
            const id_nota = paginaDados.urlDados.id_nota
            const urlNota: LinkEndpoint = {
                endpoint: ApiEndpoints.apiNew + `/nfse/nota/${id_nota}`,
                timeout: 10000,
            }
            const apiNota = await reqGetNew(urlNota)
            if (apiNota.status === 200) {
                notaAux = apiNota.data
            }
        }

        if (Object.keys(empresaAux).length > 0) {
            const apiEmpresasInfo = await reqGetNew(ApiEndpoints.nfEmpresasInfosNFSe)
            if (apiEmpresasInfo.status === 200) {
                const empresas = apiEmpresasInfo.data.filter((reg:any) => reg.empresa.id_empresa === empresaAux.id_empresa)
                if (empresas.length > 0) {
                    empresaAux["info"] = empresas[0].info
                }
            }
        }

        setEmpresa(empresaAux)
        handleResetStatus()
        setNota(notaAux)
        setPagina(paginaDados.pagina)
    }
    function definirPagina(atualizarSetPagina: boolean):iPaginaDadosDto {
        const dados = getUrlDados()
        const pagina = getNomePagina(dados)
        if (atualizarSetPagina) {
            setPagina(pagina)
        }
        return { pagina: pagina, urlDados: dados }
    }
    function getUrlDados():iUrlDadosDto {
        let urlParams: URLSearchParams = getUrlSearchParams()
        const id_empresa = urlParams.get("id_empresa")
        const id_nota = urlParams.get("id_nota")
        if (id_nota === "null") {
            return {
                id_empresa: Number(id_empresa),
                id_nota: 1,
            }
        }
        return {
            id_empresa: Number(id_empresa) > 0 ? Number(id_empresa) : 0,
            id_nota: Number(id_nota) > 0 ? Number(id_nota) : 0,
        }
    }
    function getNomePagina(dados:iUrlDadosDto): "empresas" | "notas" | "view" {
        if (dados.id_empresa > 0 && dados.id_nota === 0) {
            return "notas"
        }
        if (dados.id_empresa > 0 && dados.id_nota > 0) {
            return "view"
        }
        return "empresas"
    }
    async function getFiltros():Promise<iFiltrosDto> {
        const apiFiltros = await reqGetNew(ApiEndpoints.nfseFiltros)
        if (apiFiltros.status === 200) {
            const filtrosAux = {
                clientes: apiFiltros.data.clientes,
                clientes_tipos: apiFiltros.data.clientes_tipos,
                servicos: apiFiltros.data.servicos,
                servicos_mun: apiFiltros.data.servicos_mun,
                servicos_antigos: apiFiltros.data.servicos_antigos,
                servicos_empresas: apiFiltros.data.servicos_empresas,
                cidades: apiFiltros.data.cidades,
                empresas: apiFiltros.data.empresas,
                modelos: apiFiltros.data.modelos,
            }
            setFiltros(filtrosAux)
            return filtrosAux
        }
        return filtros
    }

    function handleEmpresaSelected(empresa: any) {
        setEmpresa(empresa)
        window.history.pushState("OB PORTUS .NET", "OB PORTUS EMPRESA NF", `/nfse?id_empresa=${empresa.id_empresa}`)
        definirPagina(true)
    }
    function handleSairEmpresa() {
        setEmpresa({})
        handleResetStatus()
        window.history.pushState("OB PORTUS .NET", "OB PORTUS EMPRESA NF", `/nfse`)
        definirPagina(true)
    }
    function handleNotaSelected(nota: any) {
        if (nota === 0) {
            window.history.pushState("OB PORTUS .NET", "OB PORTUS EMPRESA NF", `/nfse?id_empresa=${empresa.id_empresa}&id_nota=null`)
            setNota({})
        } else {
            window.history.pushState("OB PORTUS .NET", "OB PORTUS EMPRESA NF", `/nfse?id_empresa=${empresa.id_empresa}&id_nota=${nota.id}`)
            setNota(nota)
        }
        definirPagina(true)
    }
    function handleModeloOpen(modelo: any) {
        setModeloNota(modelo)
        handleNotaSelected(0)
    }
    function handleNotaSair(options:any) {
        dispatch(alterarStatusAtualizar({atualizar: options.atualizar}))
        setNota({})
        setModeloNota({})
        window.history.pushState("OB PORTUS .NET", "OB PORTUS EMPRESA NF", `/nfse?id_empresa=${empresa.id_empresa}`)
        definirPagina(true)
    }

    return (
        <div id="main">
            {pagina === "empresas" && <EmpresasSelecaoPage handleEmpresaSelected={(empresa: any) => { handleEmpresaSelected(empresa) }} />}
            {pagina === "notas" && <NotasSelecaoPage empresa={empresa} handleSairEmpresa={() => { handleSairEmpresa() }} handleOpenNota={(nota: any) => { handleNotaSelected(nota) }} filtros={filtros} handleOpenModelo={(modelo: any) => { handleModeloOpen(modelo) }} />}
            {(pagina === "view") && <ViewNotaPage empresa={empresa} handleSairNota={(options:any) => { handleNotaSair(options) }} nota={nota} filtros={filtros} modelo={modeloNota} />}
        </div>
    )
}
interface iUrlDadosDto {
    id_empresa: number
    id_nota: number
}
interface iPaginaDadosDto {
    urlDados: iUrlDadosDto
    pagina: "empresas" | "notas" | "view"
}
interface iFiltrosDto {
    clientes: any[]
    clientes_tipos: any[]
    servicos: any[]
    servicos_mun: any[]
    servicos_antigos: any[]
    servicos_empresas: any[]
    cidades: any[]
    empresas: any[]
    modelos: any[]
}
